import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from './auth.service';


@Injectable()
export class AuthGuardService implements CanActivate {
    constructor(public auth: AuthService, public router: Router) {

    }

    async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        const isAuthenticated =  await this.auth.isAuthenticated();
        if (!isAuthenticated) {
            // not logged in so redirect to login page with the return url
            this.router.navigateByUrl('/auth/login', { queryParams: { returnUrl: state.url } });
        }
        return isAuthenticated;
    }
}